import React from 'react';
import { Button } from 'antd';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { stopTimer } from 'modules/blok-test';
import { globalConst, setConfirmationModal } from 'modules/global';

import { Modal } from 'components';

import { useFinishTest } from '../hooks';

interface IProps {
  ticketId?: number;
}

export const FinishConfirmModal: React.FC<IProps> = ({ ticketId }) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const { replace } = useRouter();
  const open = useAppSelector(({ confirmationModal }) => confirmationModal.open);
  const isRouteLoading = useAppSelector(({ routeLoading }) => routeLoading.isRouteLoading);
  const { mutate, isLoading } = useFinishTest();

  const onOk = () => {
    mutate(ticketId, {
      onSuccess: async () => {
        await replace(`${globalConst.pageNames.DTM_RESULT}/${ticketId}`);
        dispatch(setConfirmationModal(false));
      }
    });
    dispatch(stopTimer());
  };

  const onClose = () => {
    dispatch(setConfirmationModal(false));
  };

  return (
    <Modal
      footer={false}
      open={open}
      centered
      onClose={onClose}
      width={380}
      closable={false}
      className="[&_.ant-modal-content]:!pb-0.75 [&_.ant-modal-content]:!rounded-xl [&_.ant-modal-content]:!px-3 [&_.ant-modal-content]:!pt-2"
    >
      <div className="mb-5 flex flex-col items-center justify-center">
        <div className="size-15 relative">
          <Image src="/images/confirmation.webp" fill alt="Confirmation" title="Confirmation" />
        </div>
        <p className="mt-3 text-lg font-semibold">{t('testni_yakunlashni_xohlaysizmi')}</p>
        <p className="mt-2 px-4 text-center text-gray-500">{t('testni_yakunlashni_xohlaysizmi_decs')}</p>
      </div>
      <div className="mt-10 flex items-center gap-2">
        <Button
          onClick={onClose}
          className="!py-4.5 !w-full !rounded-md !border-transparent !bg-gray-100 !text-black hover:!bg-gray-200"
        >
          {t('bekor_qilish')}
        </Button>
        <Button
          onClick={onOk}
          loading={isLoading || isRouteLoading}
          className="!py-4.5 !w-full !rounded-md !border-transparent !bg-red-600 !text-white hover:!bg-red-600"
        >
          {t('yakunlash')}
        </Button>
      </div>
    </Modal>
  );
};
